import { NavigateOptions } from 'react-router-dom';
import { NotificationMetaRo } from 'src/app/services/api.generated';

export type NotificationNavTarget = {
  link?: string | null;
  meta?: NotificationMetaRo | null;
};

/**
 * Resolve where a notification click should go.
 * Prefer explicit `link`, else `/edit/:taskId` from meta.
 */
export const resolveNotificationHref = (
  notification: NotificationNavTarget
): string | null => {
  if (notification.link?.trim()) {
    return notification.link.trim();
  }
  const taskId = notification.meta?.taskId?.trim();
  if (taskId) {
    return `/edit/${taskId}`;
  }
  return null;
};

export const resolveNotificationNavigateOptions = (
  notification: NotificationNavTarget
): NavigateOptions | undefined => {
  const workspaceId = notification.meta?.workspaceId?.trim();
  if (!workspaceId) return undefined;
  return { state: { workspaceId } };
};
